import templateUrl from "emun.auth/login.htm";
import controller from "emun.auth/login-prompt.controller";

export default {
  controller,
  templateUrl,
  binding: {
    authProvider: "@",
    password: "@",
    userName: "@",
    rememberMe: "<",
    viewOverride: "@"
  }
};
